// === FILE HEADER: Application Entry Point ===
// This file initializes the React DOM root and renders the main App component for the Chess Slider SPA.
// Structure and section anchors follow project documentation and copilot-instructions.md.
// Last updated: 2025-07-15
//
// === END FILE HEADER ===
// === COPILOT FILE RULES ===
// DO NOT DELETE THE HEADER OR FILE RULES FROM THE FILE
// DO NOT PLACE ANY CODE, HOOKS, OR LOGIC ABOVE IMPORTS. 
// All import statements must be at the very top of the file, before any other code or comments (except for a file-level comment header or license block, if present).
// React hooks (useEffect, useState, etc.) must only be called inside a React function component or custom hook, never at the top level.
// Make a copy of the file in copies folder before doing any edits.
// Updating full large files has been difficult.  You may use the copy to refer to if it helps you.
// After completing edits compare the edited file to the original and make sure nothing other than the intended changes have happened
// If there are unintended changes repair the file
// After user approves the copy may be deleted
// DO NOT USE INLINE STYLES ALL STYLES MUST BE DEFINED IN THE PROPER FILE AND IMPORTED
// === END COPILOT FILE RULES ===
/**
 * File: src/index.js
 * Description: Application entry point that renders the React app.
 * Initializes the React DOM root and renders the main App component.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
